/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_202Inputs */

const vi_carrier_status_202 = /** @type {(inputs: Carrier_Status_202Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phiếu gửi`)
};

/**

* @param {Carrier_Status_202Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_202 = /** @type {((inputs?: Carrier_Status_202Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_202Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_202(inputs)
});